import {useCheckoutFrontendHost, useShopId} from '@aboutyou/config';
import {Head} from '@aboutyou/head-elements';
import React from 'react';
import {CHECKOUT_WC_JS_PATH} from '../../../features/CheckoutPreload/checkout-constants';

export const ScayleCheckoutScript = () => {
  const checkoutFrontendHost = useCheckoutFrontendHost();
  const shopId = useShopId();

  return (
    <Head
      script={[
        {
          type: 'text/javascript',
          src: `${checkoutFrontendHost}/${CHECKOUT_WC_JS_PATH}?appId=${shopId}`,
          defer: true, // to not block HTML parsing
        },
      ]}
    />
  );
};
